/* src/app/modules/ct-status/cts-gantry-filter-dropdown/cts-gantry-filter-dropdown.component.scss */
.filter-container {
  display: flex;
  gap: 0.5rem;
  padding: 0.25rem 0.25rem 0.1875rem 0.5rem;
  align-items: center;
  border: unset;
  border-radius: 0.125rem 0.125rem 0 0;
  border-bottom: 0.0625rem solid rgba(var(--ui-1), var(--opacity-4));
  background: rgba(var(--ui-1), var(--opacity-7));
  width: 13.75rem;
  cursor: pointer;
  text-align: start;
}
.filter-container sh-icon {
  opacity: 0.6;
}
.event-date {
  font-weight: 400;
}
.event-item-group {
  display: flex;
  flex-flow: column nowrap;
  max-height: 21rem;
  width: 13.75rem;
}
.event-item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.75rem;
  height: 3rem;
  border: none;
  background: var(--base-4, #FFF);
}
.event-item sh-text {
  text-wrap: nowrap;
  text-align: start;
  width: fit-content;
}
.event-item sh-text:last-of-type {
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter-overlay {
  border-radius: 0 0 0.125rem 0.125rem;
  background: var(--base-4, #FFF);
  max-height: 25rem;
  box-shadow: 0 -0.0625rem 0.25rem 0 rgba(0, 0, 0, 0.05), 0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.1);
}
.table-header-action {
  gap: 0.6rem;
}
/*# sourceMappingURL=cts-gantry-filter-dropdown.component.css.map */
